export default __webpack_public_path__ + "4e72f6f418e6b5006e115d00da28528d.svg";